/**
 * Calculadora IMPRIVIC — v2.1
 * Soporta productos single-material y multi-material (selector dinámico).
 * Motores: lona | tela | suelo | vinilo | rigido
 *
 * Fórmula:
 *   precioM2   = p14 + (p01 - p14) × (1 - DISCOUNT_FACTORS[tramoIdx])
 *   subtotalUd = m2ud × (precioM2 + supsM2) + perim × €mlSup + nOjales × €udOjal + revProrr
 *   precioUd   = max(subtotalUd × multPlazo, precioMinimo)
 *   total      = precioUd × cantidad
 *
 * 0 en tabla de suplementos = NO DISPONIBLE en ese tramo.
 */

(function () {
  'use strict';

  // ─── TRAMOS ─────────────────────────────────────────────────────────────────

  var TRAMOS = [
    { key: 'T01', min: 1,   max: 1        },
    { key: 'T02', min: 2,   max: 3        },
    { key: 'T03', min: 4,   max: 6        },
    { key: 'T04', min: 7,   max: 12       },
    { key: 'T05', min: 13,  max: 18       },
    { key: 'T06', min: 19,  max: 24       },
    { key: 'T07', min: 25,  max: 36       },
    { key: 'T08', min: 37,  max: 49       },
    { key: 'T09', min: 50,  max: 75       },
    { key: 'T10', min: 76,  max: 120      },
    { key: 'T11', min: 121, max: 299      },
    { key: 'T12', min: 300, max: 499      },
    { key: 'T13', min: 500, max: 800      },
    { key: 'T14', min: 801, max: Infinity }
  ];

  var DISCOUNT_FACTORS = [
    0.0000, 0.0163, 0.0834, 0.1668,
    0.3335, 0.4000, 0.4334, 0.5001,
    0.5833, 0.6667, 0.7001, 0.7666,
    0.9166, 1.0000
  ];

  // ─── HELPERS ────────────────────────────────────────────────────────────────

  var fmt = function (n) {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency', currency: 'EUR',
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(n);
  };

  // Importe sin símbolo con formato español (6 -> "6,00"), para textos tipo "+6,00 €/m²"
  var fmtImporte = function (n) {
    return new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);
  };

  // m²: hasta 4 decimales, pero sin ceros de relleno (2.0020 -> 2.002, 2.0000 -> 2)
  var fmtM2 = function (n) {
    return n.toFixed(4).replace(/0+$/, '').replace(/\.$/, '');
  };

  // Vista previa local (antes de subir nada): imágenes se muestran vía
  // URL.createObjectURL, el resto de tipos (PDF, AI, PSD...) usa el icono genérico.
  function showLocalPreview(imgEl, iconEl, file) {
    if (!imgEl || !iconEl || !file) return;
    if (file.type && file.type.indexOf('image/') === 0) {
      imgEl.onerror = function () { imgEl.style.display = 'none'; iconEl.style.display = 'block'; };
      imgEl.onload  = function () { imgEl.style.display = 'block'; iconEl.style.display = 'none'; };
      imgEl.src = URL.createObjectURL(file);
    } else {
      imgEl.style.display = 'none';
      iconEl.style.display = 'block';
    }
  }

  // Vista previa de un archivo ya subido (restaurado desde ?edit_line=): el
  // Worker sirve el archivo tal cual, así que si es una imagen carga directa.
  function showRemotePreview(imgEl, iconEl, url) {
    if (!imgEl || !iconEl || !url) return;
    imgEl.onerror = function () { imgEl.style.display = 'none'; iconEl.style.display = 'block'; };
    imgEl.onload  = function () { imgEl.style.display = 'block'; iconEl.style.display = 'none'; };
    imgEl.src = url;
  }

  // Sube el archivo al propio Worker (sin depender de ningún servicio externo);
  // se llama solo en el momento de añadir al carrito, no al seleccionar el archivo.
  // El nombre original va tras '#': el Worker lo ignora (no se envía al
  // servidor) y el carrito lo usa para mostrar el nombre en vez del código.
  function uploadArchivoFile(pricingEndpoint, file) {
    var formData = new FormData();
    formData.append('file', file, file.name);
    return fetch(pricingEndpoint + '/upload-file', { method: 'POST', body: formData })
      .then(function (res) { if (!res.ok) throw new Error('No se pudo subir el archivo'); return res.json(); })
      .then(function (data) { return data.url + '#' + encodeURIComponent(data.filename || file.name); });
  }

  function archivoNombre(url) {
    var last = String(url || '').split('/').pop();
    if (last.indexOf('#') === -1) return last;
    try { return decodeURIComponent(last.split('#').pop()); } catch (e) { return last.split('#').pop(); }
  }

  // Mismo límite que el Worker (FILE_MAX_SIZE_BYTES): así se avisa al momento
  // en vez de esperar minutos a que la subida falle.
  var ARCHIVO_MAX_MB = 20;
  function archivoDemasiadoGrande(file) {
    return !!file && file.size > ARCHIVO_MAX_MB * 1024 * 1024;
  }
  function mensajeArchivoGrande(file) {
    return '⚠️ "' + file.name + '" pesa ' + Math.round(file.size / (1024 * 1024)) + ' MB y el máximo es ' + ARCHIVO_MAX_MB +
      ' MB. Pega un enlace de descarga (WeTransfer, Google Drive, Dropbox...) en el campo de abajo.';
  }

  function getTramoIndex(m2Total) {
    var m2 = Math.ceil(Math.max(m2Total, 1));
    for (var i = 0; i < TRAMOS.length; i++) {
      if (m2 >= TRAMOS[i].min && m2 <= TRAMOS[i].max) return i;
    }
    return TRAMOS.length - 1;
  }

  function getPrecioM2(mat, tramoIdx) {
    return mat.p14 + (mat.p01 - mat.p14) * (1 - DISCOUNT_FACTORS[tramoIdx]);
  }

  function getLaminadoM2(mat, tramoIdx) {
    if (!mat.laminadoP01 || !mat.laminadoP14) return 0;
    return mat.laminadoP14 + (mat.laminadoP01 - mat.laminadoP14) * (1 - DISCOUNT_FACTORS[tramoIdx]);
  }

  // ─── CALCULADORA ────────────────────────────────────────────────────────────

  function ImprivicCalculator(container) {
    var cfg = window.IMPRIVIC_CONFIG;
    if (!cfg || !cfg.motor) {
      console.warn('[ImprivicCalc] IMPRIVIC_CONFIG no encontrado');
      return;
    }

    this.container = container;
    this.motor     = cfg.motor;
    this.cfg       = cfg;
    this.variantId = container.dataset.variantId;
    this.isMulti   = cfg.isMulti === true;
    this._last     = null;
    this._editingLineKey = null;

    this._bindElements();
    this._setDefaults();
    this._bindEvents();
    this._bindImageButtonGroups();
    this._syncImageButtonGroups();
    this._calculate();
    this._checkEditMode();
  }

  ImprivicCalculator.prototype._el = function (id) {
    return this.container.querySelector('#' + id) || document.getElementById(id);
  };

  ImprivicCalculator.prototype._bindElements = function () {
    this.elMaterial       = this._el('calc-material');
    this.elAncho          = this._el('calc-ancho');
    this.elAlto           = this._el('calc-alto');
    this.elCantidad       = this._el('calc-cantidad');
    this.elCorte          = this._el('calc-corte');
    this.elLaminado       = this._el('calc-laminado');
    this.elLaminadoSec    = this._el('calc-laminado-section');
    this.elAdhesivado     = this._el('calc-adhesivado');
    this.elBarnizado      = this._el('calc-barnizado');
    this.elRefuerzo       = this._el('calc-refuerzo');
    this.elPosWrapper     = this._el('calc-posicion-refuerzo-wrapper');
    this.elPosicion       = this._el('calc-posicion-refuerzo');
    this.elJaretonWrapper = this._el('calc-jareton-wrapper');
    this.elJaretonDiam    = this._el('calc-jareton-diametro');
    this.elRefuerzoAviso  = this._el('calc-refuerzo-aviso');
    this.elOjal           = this._el('calc-ojal');
    this.elOjalOpciones   = this._el('calc-ojal-opciones');
    this.elOjalOpRigido   = this._el('calc-ojal-opciones-rigido');
    this.elDistanciaOjal  = this._el('calc-distancia-ojal');
    this.elPosicionOjal   = this._el('calc-posicion-ojal');
    this.elOjalAviso      = this._el('calc-ojal-aviso');
    this.elRevision       = this._el('calc-revision');
    this.elRevWrapper     = this._el('calc-revision-disenos');
    this.elNumDisenos     = this._el('calc-num-disenos');
    this.elPlazo          = this._el('calc-plazo');
    this.elPlazoAviso     = this._el('calc-plazo-aviso');
    this.elResultado      = this._el('calc-resultado');
    this.elDesglose       = this._el('calc-desglose');
    this.elPrecioTotal    = this._el('calc-precio-total');
    this.elM2Info         = this._el('calc-m2-info');
    this.elAddCart        = this._el('calc-add-cart');
    this.elCartMsg          = this._el('calc-cart-msg');
    this.elArchivoSlots     = this._el('calc-archivo-slots');
    this.elArchivoAviso     = this._el('calc-archivo-aviso');
    this.elComentarios      = this._el('calc-comentarios');
    // Un archivo por "diseño distinto" (ver calc-num-disenos): _archivoFiles
    // guarda los File aún sin subir, _archivoUrls los ya subidos (o
    // restaurados al editar), ambos indexados por posición del slot.
    this._archivoFiles      = [];
    this._archivoUrls       = [];
    this._archivoLinkValues = [];
    // Con varios diseños distintos, cuántas de las unidades totales del
    // pedido corresponden a cada diseño (deben sumar this.elCantidad).
    this._archivoQtys       = [];
    this.elPapelTransp      = this._el('calc-papel-transportador');
    this.elPapelTranspSec   = this._el('calc-papel-transportador-section');
    this.elCorteImg         = this._el('calc-corte-img');
    this.elCorteImgEl       = this._el('calc-corte-img-el');
    this.elRefuerzoImg      = this._el('calc-refuerzo-img');
    this.elRefuerzoImgEl    = this._el('calc-refuerzo-img-el');
    this.elOjalImg          = this._el('calc-ojal-img');
    this.elOjalImgEl        = this._el('calc-ojal-img-el');
    this.elLoadingOverlay   = this._el('calc-loading-overlay');
    // Mover al <body>: si se queda dentro de un contenedor con transform
    // (animaciones del tema), position:fixed deja de cubrir toda la pantalla.
    if (this.elLoadingOverlay) document.body.appendChild(this.elLoadingOverlay);
  };

  ImprivicCalculator.prototype._getActiveMaterial = function () {
    var cfg = this.cfg;
    if (this.isMulti && this.elMaterial) {
      var handle = this.elMaterial.value;
      return cfg.materialesDisponibles[handle] || cfg.material;
    }
    return cfg.material;
  };

  ImprivicCalculator.prototype._setDefaults = function () {
    var d = (this.cfg.defaults) || {};

    // Selectores comunes
    if (this.elCorte)    this.elCorte.value    = d.corte    || 'recto';
    if (this.elRevision) this.elRevision.value = d.revision || 'no';
    if (this.elPlazo)    this.elPlazo.value    = d.plazo    || '7d';

    var m = this.motor;
    if (m === 'lona') {
      if (this.elRefuerzo)      this.elRefuerzo.value      = d.refuerzo   || 'refuerzo-estandar';
      if (this.elPosicion)      this.elPosicion.value      = d.posRefuerzo|| 'perimetro';
      if (this.elOjal)          this.elOjal.value          = d.ojal       || 'ojal-policarbonato';
      if (this.elDistanciaOjal) this.elDistanciaOjal.value = d.distOjal   || '50';
    } else if (m === 'tela') {
      if (this.elRefuerzo) this.elRefuerzo.value = d.confeccion || 'sin-confeccion';
      if (this.elOjal)     this.elOjal.value     = d.ojal       || 'sin-ojales';
    } else if (m === 'suelo') {
      if (this.elCorte)     this.elCorte.value     = d.corte    || 'con-forma';
      if (this.elBarnizado) this.elBarnizado.value = d.barnizado|| 'no';
      if (this.elOjal)      this.elOjal.value      = d.ojal     || 'ojal-policarbonato';
      if (this.elDistanciaOjal) this.elDistanciaOjal.value = d.distOjal || '50';
      if (this.elRevision)  this.elRevision.value  = d.revision || 'no';
      if (this.elPlazo)     this.elPlazo.value     = d.plazo    || '5d';
    } else if (m === 'vinilo') {
      if (this.elLaminado) this.elLaminado.value = d.laminado || 'no';
    } else if (m === 'rigido') {
      if (this.elLaminado)   this.elLaminado.value   = d.laminado   || 'no';
      if (this.elAdhesivado) this.elAdhesivado.value = d.adhesivado || 'no';
      if (this.elOjal)       this.elOjal.value       = d.ojal       || 'sin-ojales';
    }
  };

  ImprivicCalculator.prototype._bindEvents = function () {
    var self = this;
    var recalc = function () { self._calculate(); };

    [self.elMaterial, self.elAncho, self.elAlto, self.elCantidad,
     self.elCorte, self.elLaminado, self.elAdhesivado, self.elBarnizado,
     self.elRefuerzo, self.elOjal, self.elDistanciaOjal, self.elPosicionOjal,
     self.elRevision, self.elNumDisenos, self.elPlazo, self.elPapelTransp
    ].forEach(function (el) {
      if (!el) return;
      el.addEventListener('change', recalc);
      if (el.type === 'number') el.addEventListener('input', recalc);
    });

    // Material change: actualizar visibilidad sección laminado
    if (self.elMaterial) {
      self.elMaterial.addEventListener('change', function () {
        self._updateLaminadoVisibility();
        self._updateCorteLabels();
        self._calculate();
      });
    }

    if (self.elRefuerzo) self.elRefuerzo.addEventListener('change', function () { self._toggleRefuerzoSub(); self._updateRefuerzoImg(); });
    if (self.elCorte)   self.elCorte.addEventListener('change',   function () { self._togglePapelTransportador(); self._updateCorteImg(); });
    self._togglePapelTransportador();
    if (self.elOjal)     self.elOjal.addEventListener('change',     function () { self._toggleOjalSub(); self._updateOjalImg(); });
    if (self.elRevision) self.elRevision.addEventListener('change', function () { self._toggleRevisionSub(); });

    self._toggleRefuerzoSub();
    self._toggleOjalSub();
    self._toggleRevisionSub();
    self._updateLaminadoVisibility();
    self._updateCorteLabels();
    self._updateCorteImg();
    self._updateRefuerzoImg();
    self._updateOjalImg();

    if (self.elAddCart) self.elAddCart.addEventListener('click', function () { self._addToCart(); });

    // ── Subida de archivo(s) (propia, sin dependencias externas) ─────────────
    // Cada archivo se queda en memoria (this._archivoFiles[i]) y solo se sube
    // al Worker en el momento de "Añadir al carrito" (ver _addToCart). El
    // número de "slots" sigue a "Nº de diseños distintos".
    if (self.elNumDisenos) {
      self.elNumDisenos.addEventListener('input',  function () { self._clampNumDisenos(); self._renderArchivoSlots(); });
      self.elNumDisenos.addEventListener('change', function () { self._clampNumDisenos(); self._renderArchivoSlots(); });
    }
    // La cantidad total afecta a cuántas unidades hay que repartir entre
    // diseños; no se reconstruyen los slots (perdería lo ya subido), solo
    // se refresca el resumen de reparto (y el tope de nº de diseños).
    if (self.elCantidad) {
      self.elCantidad.addEventListener('input',  function () { self._clampNumDisenos(); self._updateArchivoQtySummary(); });
      self.elCantidad.addEventListener('change', function () { self._clampNumDisenos(); self._updateArchivoQtySummary(); });
    }
    self._clampNumDisenos();
    self._renderArchivoSlots();
  };

  // No tiene sentido pedir más diseños distintos que unidades del pedido
  // (cada diseño necesita al menos 1 unidad propia), y como mucho MAX_DISENOS
  // (tope acordado con IMPRIVIC). Lo usan las dos calculadoras.
  var MAX_DISENOS = 20;
  function clampNumDisenos() {
    if (!this.elNumDisenos) return;
    var cantidad = parseInt(this.elCantidad ? this.elCantidad.value : 1, 10) || 1;
    var max = Math.min(cantidad, MAX_DISENOS);
    this.elNumDisenos.max = max;
    var actual = parseInt(this.elNumDisenos.value, 10) || 1;
    if (actual > max) this.elNumDisenos.value = max;
  }
  ImprivicCalculator.prototype._clampNumDisenos = clampNumDisenos;

  // Cuántos archivos hacen falta: 1 salvo que haya varios diseños distintos.
  ImprivicCalculator.prototype._requiredArchivoCount = function () {
    var n = this.elNumDisenos ? parseInt(this.elNumDisenos.value, 10) : 1;
    return (n && n > 0) ? n : 1;
  };

  // (Re)genera los bloques de subida: uno por diseño distinto. Con 1 solo
  // diseño se mantiene además la opción de pegar un link externo; con varios,
  // cada diseño necesita su propio archivo (para no mezclar cuál es cuál).
  ImprivicCalculator.prototype._renderArchivoSlots = function () {
    if (!this.elArchivoSlots) return;
    var self = this;
    var count = this._requiredArchivoCount();

    // Recortar el estado si ahora hacen falta menos archivos que antes.
    this._archivoFiles.length = count;
    this._archivoUrls.length = count;
    this._archivoLinkValues.length = count;
    this._archivoQtys.length = count;

    // Reparto por defecto de las unidades entre diseños (solo para los
    // slots que aún no tengan un valor asignado, para no pisar lo editado).
    if (count > 1) {
      var cantidadTotal = parseInt(this.elCantidad ? this.elCantidad.value : 1) || 0;
      var base  = Math.floor(cantidadTotal / count);
      var resto = cantidadTotal - base * count;
      for (var qi = 0; qi < count; qi++) {
        if (this._archivoQtys[qi] === undefined || this._archivoQtys[qi] === null) {
          this._archivoQtys[qi] = base + (qi === count - 1 ? resto : 0);
        }
      }
    }

    if (this.elArchivoAviso) {
      var esPlantilla = this.cfg && this.cfg.hasPlantilla;
      if (count > 1) {
        this.elArchivoAviso.textContent = esPlantilla
          ? 'Debes subir la plantilla rellenada para cada uno de los ' + count + ' diseños distintos antes de añadir al carrito.'
          : 'Debes subir un archivo por cada uno de los ' + count + ' diseños distintos antes de añadir al carrito.';
      } else {
        this.elArchivoAviso.textContent = esPlantilla
          ? 'Debes descargar la plantilla, completarla y subirla aquí (o pegar un link) antes de añadir al carrito.'
          : 'Debes subir tu archivo de diseño (o pegar un link) antes de añadir al carrito.';
      }
    }

    var html = '';
    for (var i = 0; i < count; i++) {
      html += '' +
        '<div class="imprivic-calc__archivo-slot" data-idx="' + i + '">' +
          (count > 1 ? '<p class="imprivic-calc__upload-desc">Diseño ' + (i + 1) + '</p>' : '') +
          (count > 1 ?
            '<label class="imprivic-calc__label imprivic-calc__qty-label">Unidades de este diseño</label>' +
            '<input type="number" min="1" step="1" class="imprivic-calc__input imprivic-calc__archivo-qty" data-idx="' + i + '" value="' + (this._archivoQtys[i] || 0) + '">'
          : '') +
          '<div class="imprivic-calc__upload-widget">' +
            '<input type="file" id="calc-archivo-upload-' + i + '" class="imprivic-calc__upload-input" data-idx="' + i + '">' +
            '<label class="imprivic-calc__upload-btn" for="calc-archivo-upload-' + i + '">📎 Subir archivo</label>' +
          '</div>' +
          '<p class="imprivic-calc__upload-hint">Máximo ' + ARCHIVO_MAX_MB + ' MB por archivo. Si pesa más, pega un enlace de descarga.</p>' +
          '<div class="imprivic-calc__aviso imprivic-calc__archivo-error" data-idx="' + i + '" style="display:none"></div>' +
          '<div class="imprivic-calc__upload-preview" data-idx="' + i + '" style="display:none">' +
            '<div class="imprivic-calc__upload-preview-inner">' +
              '<div class="imprivic-calc__upload-thumb">' +
                '<img src="" alt="" width="80" height="80" style="display:none">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>' +
              '</div>' +
              '<span class="imprivic-calc__upload-filename"></span>' +
            '</div>' +
            '<button type="button" class="imprivic-calc__upload-remove" data-idx="' + i + '" title="Eliminar archivo">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>' +
              'Eliminar' +
            '</button>' +
          '</div>' +
          '<div class="imprivic-calc__upload-or"><span>o pega un link externo</span></div>' +
          '<input type="url" class="imprivic-calc__input imprivic-calc__upload-link imprivic-calc__archivo-link" data-idx="' + i + '" placeholder="https://drive.google.com/...">' +
        '</div>';
    }
    if (count > 1) html += '<p class="imprivic-calc__archivo-qty-summary"></p>';
    this.elArchivoSlots.innerHTML = html;

    this.elArchivoSlots.querySelectorAll('.imprivic-calc__upload-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var idx = parseInt(input.dataset.idx, 10);
        var file = input.files && input.files[0];
        if (!file) return;
        var errEl = self.elArchivoSlots.querySelector('.imprivic-calc__archivo-error[data-idx="' + idx + '"]');
        if (archivoDemasiadoGrande(file)) {
          input.value = '';
          if (errEl) { errEl.textContent = mensajeArchivoGrande(file); errEl.style.display = 'block'; }
          return;
        }
        if (errEl) errEl.style.display = 'none';
        self._archivoFiles[idx] = file;
        self._archivoUrls[idx] = '';
        self._showArchivoSlotPreview(idx, file, null);
        self._refreshAddCartState();
      });
    });
    this.elArchivoSlots.querySelectorAll('.imprivic-calc__upload-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.idx, 10);
        self._archivoFiles[idx] = null;
        self._archivoUrls[idx] = '';
        var fileInput = self.elArchivoSlots.querySelector('#calc-archivo-upload-' + idx);
        if (fileInput) fileInput.value = '';
        var preview = self.elArchivoSlots.querySelector('.imprivic-calc__upload-preview[data-idx="' + idx + '"]');
        if (preview) preview.style.display = 'none';
        self._refreshAddCartState();
      });
    });
    this.elArchivoSlots.querySelectorAll('.imprivic-calc__archivo-link').forEach(function (linkEl) {
      var idx = parseInt(linkEl.dataset.idx, 10);
      linkEl.value = self._archivoLinkValues[idx] || '';
      linkEl.addEventListener('input', function () {
        self._archivoLinkValues[idx] = linkEl.value.trim();
        self._refreshAddCartState();
      });
    });
    this.elArchivoSlots.querySelectorAll('.imprivic-calc__archivo-qty').forEach(function (qtyEl) {
      var idx = parseInt(qtyEl.dataset.idx, 10);
      qtyEl.addEventListener('input', function () {
        self._setArchivoQty(idx, parseInt(qtyEl.value, 10) || 0);
      });
    });

    // Repintar el estado ya conocido (útil al restaurar desde ?edit_line=).
    for (var j = 0; j < count; j++) {
      if (this._archivoFiles[j]) this._showArchivoSlotPreview(j, this._archivoFiles[j], null);
      else if (this._archivoUrls[j]) this._showArchivoSlotPreview(j, null, this._archivoUrls[j]);
    }

    this._updateArchivoQtySummary();
  };

  // Al cambiar las unidades de un diseño, reparte automáticamente el resto
  // entre los demás diseños (a partes iguales, el sobrante va al último),
  // así el usuario no tiene que cuadrar la suma a mano.
  ImprivicCalculator.prototype._setArchivoQty = function (idx, value) {
    var count = this._requiredArchivoCount();
    var cantidad = parseInt(this.elCantidad ? this.elCantidad.value : 1, 10) || 0;
    value = Math.max(0, Math.min(value, cantidad));
    this._archivoQtys[idx] = value;

    var otros = [];
    for (var i = 0; i < count; i++) { if (i !== idx) otros.push(i); }
    if (otros.length > 0) {
      var restante = Math.max(0, cantidad - value);
      var base  = Math.floor(restante / otros.length);
      var resto = restante - base * otros.length;
      otros.forEach(function (i, j) {
        this._archivoQtys[i] = base + (j === otros.length - 1 ? resto : 0);
      }, this);
    }

    var self = this;
    this.elArchivoSlots.querySelectorAll('.imprivic-calc__archivo-qty').forEach(function (qtyEl) {
      var i = parseInt(qtyEl.dataset.idx, 10);
      qtyEl.value = self._archivoQtys[i] || 0;
    });
    this._updateArchivoQtySummary();
    this._refreshAddCartState();
  };

  // Comprueba que la suma de unidades repartidas entre diseños coincida con
  // la cantidad total del pedido, y lo muestra junto a los slots.
  ImprivicCalculator.prototype._updateArchivoQtySummary = function () {
    var count = this._requiredArchivoCount();
    var summaryEl = this.elArchivoSlots && this.elArchivoSlots.querySelector('.imprivic-calc__archivo-qty-summary');
    if (!summaryEl || count <= 1) return;
    var cantidad = parseInt(this.elCantidad ? this.elCantidad.value : 1) || 0;
    var suma = 0;
    for (var i = 0; i < count; i++) suma += (this._archivoQtys[i] || 0);
    var ok = suma === cantidad;
    summaryEl.textContent = ok
      ? '✓ Unidades repartidas: ' + suma + ' de ' + cantidad
      : '⚠️ Unidades repartidas: ' + suma + ' de ' + cantidad + ' — deben sumar ' + cantidad;
    summaryEl.classList.toggle('imprivic-calc__archivo-qty-summary--error', !ok);
  };

  ImprivicCalculator.prototype._showArchivoSlotPreview = function (idx, file, url) {
    var preview = this.elArchivoSlots && this.elArchivoSlots.querySelector('.imprivic-calc__upload-preview[data-idx="' + idx + '"]');
    if (!preview) return;
    var nombreEl = preview.querySelector('.imprivic-calc__upload-filename');
    var imgEl    = preview.querySelector('img');
    var iconEl   = preview.querySelector('svg');
    preview.style.display = 'flex';
    if (file) {
      if (nombreEl) nombreEl.textContent = file.name;
      showLocalPreview(imgEl, iconEl, file);
    } else if (url) {
      if (nombreEl) nombreEl.textContent = archivoNombre(url);
      showRemotePreview(imgEl, iconEl, url);
    }
  };

  // Selectores tipo "imagen-botón" (corte, refuerzo/confección, ojales): al
  // hacer clic en una imagen, actualiza el <select> oculto correspondiente y
  // dispara 'change' para que el resto del motor de cálculo siga igual.
  ImprivicCalculator.prototype._bindImageButtonGroups = function () {
    var self = this;
    this.container.querySelectorAll('.imprivic-btngroup--img[data-target]').forEach(function (group) {
      var select = self._el(group.dataset.target);
      if (!select) return;
      group.querySelectorAll('.imprivic-btngroup__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          select.value = btn.dataset.value;
          group.querySelectorAll('.imprivic-btngroup__btn').forEach(function (b) { b.classList.remove('imp-active'); });
          btn.classList.add('imp-active');
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  };

  // Sincroniza qué botón aparece activo con el valor actual del <select>
  // (necesario tras aplicar valores por defecto o restaurar desde el carrito).
  ImprivicCalculator.prototype._syncImageButtonGroups = function () {
    var self = this;
    this.container.querySelectorAll('.imprivic-btngroup--img[data-target]').forEach(function (group) {
      var select = self._el(group.dataset.target);
      if (!select) return;
      group.querySelectorAll('.imprivic-btngroup__btn').forEach(function (btn) {
        btn.classList.toggle('imp-active', btn.dataset.value === select.value);
      });
    });
  };

  // Muestra/oculta sección laminado según si el material activo tiene laminado
  ImprivicCalculator.prototype._updateLaminadoVisibility = function () {
    if (!this.elLaminadoSec) return;
    var mat = this._getActiveMaterial();
    var show = mat && mat.tieneLaminado === 'true';
    this.elLaminadoSec.style.display = show ? 'block' : 'none';
    if (!show && this.elLaminado) this.elLaminado.value = 'no';
  };

  // Suplemento €/m² de corte para un material dado: usa el precio propio del
  // material si lo tiene definido (>0), si no cae al de la subcategoría.
  ImprivicCalculator.prototype._getCorteExtra = function (corteVal, mat) {
    var cfg = this.cfg;
    mat = mat || {};
    if (corteVal === 'recto') {
      return mat.precioCorteRecto > 0 ? mat.precioCorteRecto : 0;
    } else if (corteVal === 'silueta' || corteVal === 'con-forma') {
      return (mat.precioCorteSimlueta > 0 ? mat.precioCorteSimlueta : (corteVal === 'con-forma' ? cfg.corte.conForma : cfg.corte.silueta)) || 0;
    } else if (corteVal === 'multicorte') {
      return (mat.precioCorteMulticorte > 0 ? mat.precioCorteMulticorte : cfg.corte.multicorte) || 0;
    } else if (corteVal === 'texto-grande' || corteVal === 'texto-pequeno' || corteVal === 'texto' || corteVal === 'silueta-texto') {
      return (mat.precioCorteTexto > 0 ? mat.precioCorteTexto : (corteVal === 'texto-pequeno' ? cfg.corte.textoPequeno : cfg.corte.textoGrande)) || 0;
    }
    return 0;
  };

  // Actualiza los precios mostrados en el <select> y los botones-imagen de
  // corte según el material activo (pueden tener su propio precio de corte,
  // distinto al de la subcategoría con el que se renderizó el Liquid).
  ImprivicCalculator.prototype._updateCorteLabels = function () {
    var self = this;
    var mat  = this._getActiveMaterial();

    if (this.elCorte) {
      Array.prototype.forEach.call(this.elCorte.options, function (opt) {
        if (opt.value === 'recto') return;
        var extra = self._getCorteExtra(opt.value, mat);
        opt.textContent = opt.textContent.replace(/\+[\d.,]+\s*€\/m²/, '+' + fmtImporte(extra) + ' €/m²');
      });
    }

    this.container.querySelectorAll('.imprivic-btngroup--img[data-target="calc-corte"] .imprivic-btngroup__btn').forEach(function (btn) {
      var val = btn.dataset.value;
      if (val === 'recto') return;
      var extra  = self._getCorteExtra(val, mat);
      var subEl  = btn.querySelector('.imprivic-btngroup__sub');
      if (subEl) subEl.textContent = '+' + fmtImporte(extra) + ' €/m²';
    });
  };

  ImprivicCalculator.prototype._updateCorteImg = function () {
    if (!this.elCorteImg || !this.elCorteImgEl) return;
    var imgs = (this.cfg.imagenes) || {};
    var val = this.elCorte ? this.elCorte.value : '';
    var map = {
      'recto':         imgs.corteRecto,
      'con-forma':     imgs.corteForma,
      'silueta':       imgs.corteSilueta,
      'multicorte':    imgs.corteMulticorte,
      'texto-grande':  imgs.corteTextoGrande,
      'texto-pequeno': imgs.corteTextoPequeno,
      'texto':         imgs.corteTextoGrande,
    };
    var url = map[val] || '';
    if (url) {
      this.elCorteImgEl.src = url;
      this.elCorteImgEl.alt = val;
      this.elCorteImg.style.display = 'block';
    } else {
      this.elCorteImg.style.display = 'none';
    }
  };

  ImprivicCalculator.prototype._updateRefuerzoImg = function () {
    if (!this.elRefuerzoImg || !this.elRefuerzoImgEl) return;
    var imgs = (this.cfg.imagenes) || {};
    var val = this.elRefuerzo ? this.elRefuerzo.value : '';
    var map = {
      'refuerzo-estandar':    imgs.refuerzoEstandar,
      'refuerzo-tenkeder':    imgs.refuerzoTenkeder,
      'jareton-vaina':        imgs.jareton,
      'junquillo-silicona':   imgs.junquillo,
      'dobladillo-perimetral':imgs.dobladillo,
      'velcro-cosido':        imgs.velcroCosido,
      'refuerzo-cinta':       imgs.refuerzoCinta,
    };
    var url = map[val] || '';
    if (url) {
      this.elRefuerzoImgEl.src = url;
      this.elRefuerzoImgEl.alt = val;
      this.elRefuerzoImg.style.display = 'block';
    } else {
      this.elRefuerzoImg.style.display = 'none';
    }
  };

  ImprivicCalculator.prototype._updateOjalImg = function () {
    if (!this.elOjalImg || !this.elOjalImgEl) return;
    var imgs = (this.cfg.imagenes) || {};
    var val = this.elOjal ? this.elOjal.value : '';
    var map = {
      'ojal-policarbonato': imgs.ojalPoli,
      'ojal-metalico':      imgs.ojalMetal,
    };
    var url = map[val] || '';
    if (url) {
      this.elOjalImgEl.src = url;
      this.elOjalImgEl.alt = val;
      this.elOjalImg.style.display = 'block';
    } else {
      this.elOjalImg.style.display = 'none';
    }
  };

  ImprivicCalculator.prototype._togglePapelTransportador = function () {
    if (!this.elPapelTranspSec || this.motor !== 'vinilo') return;
    var val = this.elCorte ? this.elCorte.value : 'recto';
    var show = val === 'texto-grande' || val === 'texto-pequeno';
    this.elPapelTranspSec.style.display = show ? 'block' : 'none';
    if (!show && this.elPapelTransp) this.elPapelTransp.checked = false;
  };

  ImprivicCalculator.prototype._toggleRefuerzoSub = function () {
    if (!this.elRefuerzo) return;
    var val   = this.elRefuerzo.value;
    var esSin = val === 'sin-refuerzo' || val === 'sin-confeccion';
    var esJar = val === 'jareton-vaina';
    if (this.elPosWrapper)     this.elPosWrapper.style.display     = esSin ? 'none' : 'block';
    if (this.elJaretonWrapper) this.elJaretonWrapper.style.display = esJar ? 'block' : 'none';
  };

  ImprivicCalculator.prototype._toggleOjalSub = function () {
    if (!this.elOjal) return;
    var sinOjal = this.elOjal.value === 'sin-ojales';
    if (this.elOjalOpciones)  this.elOjalOpciones.style.display  = sinOjal ? 'none' : 'block';
    if (this.elOjalOpRigido)  this.elOjalOpRigido.style.display  = (sinOjal || this.motor !== 'rigido') ? 'none' : 'block';
  };

  ImprivicCalculator.prototype._toggleRevisionSub = function () {
    // Nº diseños siempre visible
    if (this.elRevWrapper) this.elRevWrapper.style.display = 'block';
  };

  ImprivicCalculator.prototype._getSuplemento = function (key) {
    var sups = this.cfg.suplementos || {};
    if (sups[key]) return sups[key];
    for (var h in sups) { if (h.indexOf(key) !== -1) return sups[h]; }
    return null;
  };

  // Solo hay 3 tramos de precio definidos (T01-T05, T06-T09, T10-T11); para
  // tramos mayores (lonas grandes) se sigue aplicando el último precio
  // conocido en vez de marcarlo como "no disponible".
  ImprivicCalculator.prototype._precioOjalMetal = function (tramoIdx) {
    var oj = this.cfg.ojales;
    if (tramoIdx <= 4) return oj.precioOjalMetalicoT01;
    if (tramoIdx <= 8) return oj.precioOjalMetalicoT06;
    return oj.precioOjalMetalicoT10;
  };

  ImprivicCalculator.prototype._updatePlazoOptions = function (tramoIdx) {
    if (!this.elPlazo) return;
    var plazos = this.cfg.plazos;
    var currentVal = this.elPlazo.value;
    var currentOk = false, firstOk = null;
    Array.prototype.forEach.call(this.elPlazo.options, function (opt) {
      var p  = plazos[opt.value];
      var ok = p && tramoIdx <= p.maxTramoIdx;
      opt.disabled = !ok;
      if (ok) {
        if (opt.value === currentVal) currentOk = true;
        if (firstOk === null) firstOk = opt.value;
      }
    });
    if (!currentOk && firstOk) this.elPlazo.value = firstOk;
    if (this.elPlazoAviso) this.elPlazoAviso.style.display = 'none';
  };

  // ─── CÁLCULO ─────────────────────────────────────────────────────────────────

  ImprivicCalculator.prototype._calculate = function () {
    var cfg      = this.cfg;
    var motor    = this.motor;
    var mat      = this._getActiveMaterial();
    var ancho    = parseFloat(this.elAncho    ? this.elAncho.value    : 0) || 0;
    var alto     = parseFloat(this.elAlto     ? this.elAlto.value     : 0) || 0;
    var cantidad = parseInt(  this.elCantidad ? this.elCantidad.value : 1) || 1;

    if (ancho <= 0 || alto <= 0 || cantidad <= 0) { this._hideResult(); return; }

    var minMedida = cfg.medidaMinimaCm || 1;
    if (ancho < minMedida || alto < minMedida) { this._showMedidaAviso(minMedida); this._hideResult(); return; }
    this._hideMedidaAviso();
    var anchoM  = ancho / 100;
    var altoM   = alto  / 100;
    var m2Ud    = anchoM * altoM;
    var m2Total = m2Ud * cantidad;
    var perim   = 2 * (anchoM + altoM);
    // El tramo de precio depende del volumen TOTAL del pedido (m2Total): a
    // más cantidad, mejor precio/m² para todas las unidades.
    var tIdx    = getTramoIndex(m2Total);
    var tramo   = TRAMOS[tIdx];

    this._updatePlazoOptions(tIdx);

    if (this.elM2Info) {
      var tLabel = tramo.min === tramo.max ? tramo.min : (tramo.min + ' a ' + (tramo.max === Infinity ? '∞' : tramo.max));
      this.elM2Info.style.display = 'block';
      var m2UdDisp = Number.isInteger(m2Ud) ? m2Ud : parseFloat(m2Ud.toFixed(2));
      var m2TotDisp = Number.isInteger(m2Total) ? m2Total : parseFloat(m2Total.toFixed(2));
      this.elM2Info.textContent = m2UdDisp + ' m²/ud × ' + cantidad + ' = ' + m2TotDisp + ' m² → ' + tramo.key + ' (' + tLabel + ' m²)';
    }

    // ── Subtramos precio fijo (PVC 10mm para m² < 1) ─────────────────────────
    if (mat.precioSubT1 > 0 && m2Total < 1) {
      var subtramos = [
        { max: mat.precioSubT1Max, precio: mat.precioSubT1 },
        { max: mat.precioSubT2Max, precio: mat.precioSubT2 },
        { max: mat.precioSubT3Max, precio: mat.precioSubT3 },
        { max: mat.precioSubT4Max, precio: mat.precioSubT4 },
      ];
      var precioFijo = null;
      for (var s = 0; s < subtramos.length; s++) {
        if (m2Total <= subtramos[s].max) {
          precioFijo = subtramos[s].precio;
          break;
        }
      }
      if (precioFijo !== null) {
        var plazoKey = this.elPlazo ? this.elPlazo.value : '10d';
        var plazoInfo = (cfg.plazos || {})[plazoKey] || { mult: 1, maxTramoIdx: 13 };
        var plazoNombres = { '48h':'48 horas', '5d':'5 días laborables', '7d':'7 días laborables', '10d':'10 días laborables' };

        var corteVal = this.elCorte ? this.elCorte.value : 'recto';
        var corteExtra = this._getCorteExtra(corteVal, mat);
        var costoCorte = corteExtra * m2Ud;

        var adhesivadoVal = this.elAdhesivado ? this.elAdhesivado.value : 'no';
        var costoAdhesivado = (cfg.adhesivado || {})[adhesivadoVal] ? cfg.adhesivado[adhesivadoVal] * m2Ud : 0;

        var subtotalFijo = (precioFijo * m2Ud) + costoCorte + costoAdhesivado;
        var subtotalFijoConPlazo = subtotalFijo * plazoInfo.mult;

        this._last = {
          mat: mat, ancho: ancho, alto: alto, cantidad: cantidad,
          m2Ud: m2Ud, m2Total: m2Total, perim: perim, tramo: tramo, tIdx: tIdx,
          precioM2: precioFijo, corteVal: corteVal, corteExtra: corteExtra,
          laminadoVal: 'no', costoLaminado: 0,
          adhesivadoVal: adhesivadoVal, costoAdhesivado: costoAdhesivado,
          barnizadoVal: 'no', costoBarnizado: 0,
          precioMatUd: precioFijo * m2Ud, pRefMl: 0, costoRefUd: 0,
          refuerzoVal: 'sin-refuerzo', refNombre: '', refOk: false, esSinRef: true,
          ojalVal: 'sin-ojales', ojalNombre: '', ojalOk: false, esSinOjal: true,
          pOjalUd: 0, nOjales: 0, costoOjales: 0,
          distanciaOjal: null, posicionOjal: 'perimetro',
          revVal: 'no', nDis: 1, totalRev: 0, revProrr: 0,
          subtotalUd: subtotalFijo, subtotalConPlazo: subtotalFijoConPlazo * cantidad,
          mult: plazoInfo.mult, minimoAplicado: false,
          plazoNombre: plazoNombres[plazoKey] || plazoKey,
          precioUd: subtotalFijoConPlazo, precioTotal: subtotalFijoConPlazo * cantidad,
          hayIncompat: false, cfg: cfg,
          esPrecioFijo: true
        };
        this._updateUI(this._last);
        return;
      }
    }

    var precioM2 = getPrecioM2(mat, tIdx);

    // ── Suplementos €/m²
    var corteVal = this.elCorte ? this.elCorte.value : 'recto';
    var corteExtra = this._getCorteExtra(corteVal, mat);

    var laminadoVal   = this.elLaminado   ? this.elLaminado.value   : 'no';
    var costoLaminado = (laminadoVal !== 'no' && mat.tieneLaminado === 'true') ? getLaminadoM2(mat, tIdx) : 0;

    var adhesivadoVal   = this.elAdhesivado ? this.elAdhesivado.value : 'no';
    var costoAdhesivado = adhesivadoVal === 'perimetral' ? cfg.adhesivado.perimetral : (adhesivadoVal === 'completo' ? cfg.adhesivado.completo : 0);

    var barnizadoVal   = this.elBarnizado ? this.elBarnizado.value : 'no';
    var costoBarnizado = barnizadoVal !== 'no' ? cfg.barnizado.satinado : 0;

    var precioMatUd = m2Ud * (precioM2 + corteExtra + costoLaminado + costoAdhesivado + costoBarnizado);

    // ── Refuerzo / confección €/ml
    var refuerzoVal = this.elRefuerzo ? this.elRefuerzo.value : (motor === 'lona' ? 'sin-refuerzo' : 'sin-confeccion');
    var esSinRef    = refuerzoVal === 'sin-refuerzo' || refuerzoVal === 'sin-confeccion';
    var refNombre   = refuerzoVal;
    var refOk       = true;
    var costoRefUd  = 0;
    var pRefMl      = 0;

    if (!esSinRef) {
      var refKeyMap = {
        'refuerzo-estandar':    'refuerzo-estandar-lonas',
        'refuerzo-tenkeder':    'refuerzo-tenkeder-lonas',
        'jareton-vaina':        motor === 'lona' ? 'jareton-vaina-lonas' : 'jareton-vaina-telas',
        'junquillo-silicona':   'junquillo-silicona-telas',
        'dobladillo-perimetral':'dobladillo-perimetral-telas',
        'velcro-cosido':        'velcro-cosido-telas',
        'refuerzo-cinta':       'refuerzo-cinta-telas',
      };
      var sup = this._getSuplemento(refKeyMap[refuerzoVal] || refuerzoVal);
      if (sup) {
        refNombre = sup.nombre;
        pRefMl    = sup.precios[tIdx];
        refOk     = pRefMl > 0;
        if (refOk) costoRefUd = perim * pRefMl;
      } else {
        refOk = false;
      }
    }
    if (this.elRefuerzoAviso) this.elRefuerzoAviso.style.display = (!esSinRef && !refOk) ? 'block' : 'none';

    // ── Ojales
    var ojalVal    = this.elOjal ? this.elOjal.value : 'sin-ojales';
    var esSinOjal  = ojalVal === 'sin-ojales';
    var ojalNombre = 'Sin ojales';
    var ojalOk     = true;
    var pOjalUd    = 0;
    var nOjales    = 0;
    var costoOjales = 0;

    if (!esSinOjal) {
      var distVal = this.elDistanciaOjal ? this.elDistanciaOjal.value : '50';
      if (motor === 'rigido') {
        var nFijo = distVal === 'esquinas' ? 4 : 8;
        if (ojalVal === 'ojal-policarbonato' && cfg.ojales.precioOjalPoli > 0) {
          ojalOk = true; ojalNombre = 'Ojal de policarbonato transparente';
          pOjalUd = cfg.ojales.precioOjalPoli; nOjales = nFijo; costoOjales = nOjales * pOjalUd;
        }
      } else {
        var factor = (cfg.distanciasOjal || {})[distVal] || 2;
        // Calcular perímetro efectivo según posición de ojales
        var posOjalVal = this.elPosicionOjal ? this.elPosicionOjal.value : 'perimetro';
        var perimOjal = perim;
        if (posOjalVal === 'arriba-abajo') perimOjal = 2 * anchoM;
        else if (posOjalVal === 'laterales') perimOjal = 2 * altoM;
        else if (posOjalVal === 'solo-arriba') perimOjal = anchoM;
        else if (posOjalVal === 'solo-abajo') perimOjal = anchoM;
        if (ojalVal === 'ojal-policarbonato' && cfg.ojales.precioOjalPoli > 0) {
          ojalOk = true; ojalNombre = 'Ojal de policarbonato transparente';
          pOjalUd = cfg.ojales.precioOjalPoli; nOjales = Math.round(perimOjal * factor); costoOjales = nOjales * pOjalUd;
        } else if (ojalVal === 'ojal-metalico' && motor === 'lona') {
          var pMetal = this._precioOjalMetal(tIdx);
          ojalOk = pMetal > 0; ojalNombre = 'Ojal metálico ovalado'; pOjalUd = pMetal;
          if (ojalOk) { nOjales = Math.round(perimOjal * factor); costoOjales = nOjales * pMetal; }
        } else { ojalOk = false; }
      }
    }
    if (this.elOjalAviso) this.elOjalAviso.style.display = (!esSinOjal && !ojalOk) ? 'block' : 'none';

    var hayIncompat = (!esSinRef && !refOk) || (!esSinOjal && !ojalOk);

    // ── Revisión
    var revVal   = this.elRevision ? this.elRevision.value : 'no';
    var nDis     = parseInt(this.elNumDisenos ? this.elNumDisenos.value : 1) || 1;
    var totalRev = revVal === 'si' ? nDis * cfg.revisionPrecio : 0;
    var revProrr = totalRev / cantidad;

    // ── Precio final
    // El mínimo aplica al TOTAL del pedido, no por unidad.
    // Si 2ud → el mínimo sigue siendo 30€ hasta que 2×subtotal×mult supere 30€.
    var subtotalUd      = precioMatUd + costoRefUd + costoOjales + revProrr;
    var plazoKey        = this.elPlazo ? this.elPlazo.value : '10d';
    var plazoInfo       = (cfg.plazos || {})[plazoKey] || { mult: 1, maxTramoIdx: 13 };
    var totalSinMinimo  = subtotalUd * plazoInfo.mult * cantidad;
    var minimoAplicado  = totalSinMinimo < cfg.precioMinimo;
    var precioTotal     = Math.max(totalSinMinimo, cfg.precioMinimo);
    var precioUd        = precioTotal / cantidad;

    this._last = {
      mat, ancho, alto, cantidad, m2Ud, m2Total, perim, tramo, tIdx,
      precioM2, corteVal, corteExtra, laminadoVal, costoLaminado,
      adhesivadoVal, costoAdhesivado, barnizadoVal, costoBarnizado,
      precioMatUd, pRefMl, costoRefUd,
      refuerzoVal, refNombre, refOk, esSinRef,
      posNombre: this.elPosicion ? this.elPosicion.options[this.elPosicion.selectedIndex].text : '',
      jaretonDiam: this.elJaretonDiam ? this.elJaretonDiam.value : null,
      ojalVal, ojalNombre, ojalOk, esSinOjal, pOjalUd, nOjales, costoOjales,
      distanciaOjal: this.elDistanciaOjal ? this.elDistanciaOjal.value : null,
      posicionOjal: this.elPosicionOjal ? this.elPosicionOjal.value : 'perimetro',
      revVal, nDis, totalRev, revProrr,
      subtotalUd, mult: plazoInfo.mult, minimoAplicado,
      plazoNombre: ({ '48h':'48 horas','5d':'5 días laborables','7d':'7 días laborables','10d':'10 días laborables' })[plazoKey] || plazoKey,
      precioUd, precioTotal, hayIncompat
    };

    this._updateUI(this._last);
  };

  // ─── UI ──────────────────────────────────────────────────────────────────────

  ImprivicCalculator.prototype._updateUI = function (r) {
    if (!this.elDesglose) return;
    var rows = [];

    rows.push('<tr><td class="imprivic-calc__label-col">Material</td><td>' + r.mat.nombre + '</td></tr>');
    rows.push('<tr><td class="imprivic-calc__label-col">m² por unidad</td><td>' + fmtM2(r.m2Ud) + ' m²</td></tr>');
    rows.push('<tr><td class="imprivic-calc__label-col">m² totales pedido</td><td>' + fmtM2(r.m2Total) + ' m² → <strong>' + r.tramo.key + '</strong></td></tr>');
    rows.push('<tr><td class="imprivic-calc__label-col">Precio €/m² (' + r.tramo.key + ')</td><td>' + fmt(r.precioM2) + '</td></tr>');

    if (r.corteExtra > 0)      rows.push('<tr><td class="imprivic-calc__label-col">Suplemento corte</td><td>+' + fmt(r.corteExtra) + '/m²</td></tr>');
    if (r.costoLaminado > 0)   rows.push('<tr><td class="imprivic-calc__label-col">Laminado ' + r.laminadoVal + '</td><td>+' + fmt(r.costoLaminado) + '/m²</td></tr>');
    if (r.costoAdhesivado > 0) rows.push('<tr><td class="imprivic-calc__label-col">Adhesivado ' + r.adhesivadoVal + '</td><td>+' + fmt(r.costoAdhesivado) + '/m²</td></tr>');
    if (r.costoBarnizado > 0)  rows.push('<tr><td class="imprivic-calc__label-col">Barnizado satinado</td><td>+' + fmt(r.costoBarnizado) + '/m²</td></tr>');

    rows.push('<tr><td class="imprivic-calc__label-col">Material por unidad</td><td>' + fmt(r.precioMatUd) + '</td></tr>');

    if (!r.esSinRef) {
      if (!r.refOk) {
        rows.push('<tr class="imprivic-calc__row--no-disponible"><td class="imprivic-calc__label-col">' + r.refNombre + '</td><td>⚠️ No disponible en este tramo</td></tr>');
      } else if (r.costoRefUd > 0) {
        rows.push('<tr><td class="imprivic-calc__label-col">' + r.refNombre + ' (' + r.perim.toFixed(2) + ' ml × ' + fmt(r.pRefMl) + ')</td><td>' + fmt(r.costoRefUd) + '</td></tr>');
      }
    }

    if (!r.esSinOjal) {
      if (!r.ojalOk) {
        rows.push('<tr class="imprivic-calc__row--no-disponible"><td class="imprivic-calc__label-col">' + r.ojalNombre + '</td><td>⚠️ No disponible en este tramo</td></tr>');
      } else if (r.costoOjales > 0) {
        rows.push('<tr><td class="imprivic-calc__label-col">' + r.ojalNombre + ' (' + r.nOjales + ' ud × ' + fmt(r.pOjalUd) + ')</td><td>' + fmt(r.costoOjales) + '</td></tr>');
      }
    }

    if (r.revProrr > 0) rows.push('<tr><td class="imprivic-calc__label-col">Revisión archivos (' + r.nDis + ' diseño' + (r.nDis > 1 ? 's' : '') + ' × ' + fmt(this.cfg.revisionPrecio) + ' = ' + fmt(r.totalRev) + ')</td><td>' + fmt(r.revProrr) + '</td></tr>');
    // Profesionales: revisión gratis (revisionPrecio 0), se muestra igualmente para que se vea la ventaja.
    else if (r.revVal === 'si') rows.push('<tr><td class="imprivic-calc__label-col">Revisión archivos (' + r.nDis + ' diseño' + (r.nDis > 1 ? 's' : '') + ')</td><td>Gratis</td></tr>');

    if (!r.hayIncompat) {
      rows.push('<tr class="imprivic-calc__subtotal-row"><td class="imprivic-calc__label-col">Subtotal por unidad</td><td>' + fmt(r.subtotalUd) + '</td></tr>');
      rows.push('<tr><td class="imprivic-calc__label-col">Plazo (' + r.plazoNombre + ')</td><td>× ' + r.mult.toFixed(2) + '</td></tr>');
      rows.push('<tr class="imprivic-calc__unit-row"><td class="imprivic-calc__label-col">Precio por unidad (sin IVA)</td><td>' + fmt(r.precioUd) + '</td></tr>');
      rows.push('<tr><td class="imprivic-calc__label-col">Cantidad</td><td>× ' + r.cantidad + ' uds</td></tr>');
    }

    this.elDesglose.innerHTML = '<table class="imprivic-calc__table">' + rows.join('') + '</table>';

    // Aviso cuando el precio sube al importe mínimo por producto, para que el
    // cliente entienda por qué paga más de lo que suma su configuración.
    var elMinimo = this._el('calc-minimo-aviso');
    if (elMinimo) {
      var showMinimo = !r.hayIncompat && r.minimoAplicado;
      if (showMinimo) {
        var minTxt = fmt(this.cfg.precioMinimo);
        elMinimo.textContent = 'Tu configuración no llega al mínimo de ' + minTxt + ', por eso el precio es ' + minTxt +
          '. Aprovecha: puedes aumentar medidas o unidades sin pagar más.';
      }
      elMinimo.style.display = showMinimo ? 'block' : 'none';
    }

    if (r.hayIncompat) {
      if (this.elPrecioTotal) this.elPrecioTotal.textContent = '—';
      if (this.elAddCart)     this.elAddCart.disabled = true;
      if (this.elArchivoAviso) this.elArchivoAviso.style.display = 'none';
    } else {
      if (this.elPrecioTotal) this.elPrecioTotal.textContent = fmt(r.precioTotal);
      if (this.elAddCart)     this.elAddCart.disabled = !this._hasArchivo();
      if (this.elArchivoAviso) this.elArchivoAviso.style.display = this._hasArchivo() ? 'none' : 'block';
      this._syncPagePrice(r.precioTotal);
    }

    if (this.elResultado) this.elResultado.style.display = 'block';
  };

  ImprivicCalculator.prototype._showMedidaAviso = function (min) {
    var el = this._el('calc-medida-aviso');
    if (el) { el.style.display = 'block'; el.textContent = '⚠️ La medida mínima es ' + min + ' × ' + min + ' cm.'; }
  };

  ImprivicCalculator.prototype._hideMedidaAviso = function () {
    var el = this._el('calc-medida-aviso');
    if (el) el.style.display = 'none';
  };

  ImprivicCalculator.prototype._hideResult = function () {
    if (this.elResultado) this.elResultado.style.display = 'none';
    if (this.elM2Info)    this.elM2Info.style.display    = 'none';
    if (this.elAddCart)   this.elAddCart.disabled        = true;
    this._last = null;
    document.querySelectorAll('.product__info-container .price-item--regular, .product__info-container .price-item--sale').forEach(function (el) {
      if (el.dataset.imprivicOriginal) el.textContent = el.dataset.imprivicOriginal;
    });
  };

  ImprivicCalculator.prototype._syncPagePrice = function (total) {
    document.querySelectorAll('.product__info-container .price-item--regular, .product__info-container .price-item--sale').forEach(function (el) {
      if (!el.dataset.imprivicOriginal) el.dataset.imprivicOriginal = el.textContent.trim();
      el.textContent = fmt(total);
    });
  };

  // ─── EDITAR DESDE EL CARRITO ─────────────────────────────────────────────────

  var CONFIG_FIELD_IDS = [
    'calc-material', 'calc-ancho', 'calc-alto', 'calc-cantidad', 'calc-corte',
    'calc-laminado', 'calc-adhesivado', 'calc-barnizado', 'calc-refuerzo',
    'calc-posicion-refuerzo', 'calc-jareton-diametro', 'calc-ojal',
    'calc-distancia-ojal', 'calc-posicion-ojal', 'calc-revision',
    'calc-num-disenos', 'calc-plazo', 'calc-papel-transportador', 'calc-comentarios'
  ];

  ImprivicCalculator.prototype._getConfigSnapshot = function () {
    var self = this;
    var snap = {};
    CONFIG_FIELD_IDS.forEach(function (id) {
      var el = self._el(id);
      if (!el) return;
      snap[id] = el.type === 'checkbox' ? el.checked : el.value;
    });
    if (this._requiredArchivoCount() === 1) {
      var archivoUrl = this._archivoUrls[0] || this._archivoLinkValues[0];
      if (archivoUrl) snap._archivoUrls = [archivoUrl];
    } else {
      var merged = this._archivoUrls.map(function (u, i) { return u || self._archivoLinkValues[i] || ''; });
      var withUrls = merged.filter(Boolean);
      if (withUrls.length) snap._archivoUrls = merged;
    }
    if (this._requiredArchivoCount() > 1) snap._archivoQtys = this._archivoQtys.slice();
    return snap;
  };

  ImprivicCalculator.prototype._applyConfigSnapshot = function (snap) {
    var self = this;
    Object.keys(snap).forEach(function (id) {
      if (id === '_archivoUrls' || id === '_archivoUrl') return;
      var el = self._el(id);
      if (!el) return;
      if (el.type === 'checkbox') el.checked = !!snap[id];
      else el.value = snap[id];
    });
    // Compatibilidad con líneas guardadas antes de soportar varios archivos.
    var urls = snap._archivoUrls || (snap._archivoUrl ? [snap._archivoUrl] : []);
    this._archivoUrls = urls.slice();
    this._archivoFiles = [];
    this._archivoLinkValues = [];
    this._archivoQtys = (snap._archivoQtys || []).slice();
    this._renderArchivoSlots();
    this._updateLaminadoVisibility();
    this._toggleRefuerzoSub();
    this._toggleOjalSub();
    this._toggleRevisionSub();
    this._togglePapelTransportador();
    this._updateCorteLabels();
    this._updateCorteImg();
    this._updateRefuerzoImg();
    this._updateOjalImg();
    this._syncImageButtonGroups();
    this._calculate();
  };

  // Si venimos de "editar" una línea del carrito (?edit_line=<key>), carga su
  // configuración guardada y la aplica a los controles, y cambia el botón a
  // "Actualizar carrito" para reemplazar esa línea en vez de añadir una nueva.
  ImprivicCalculator.prototype._checkEditMode = function () {
    var self = this;
    var editKey = new URLSearchParams(window.location.search).get('edit_line');
    if (!editKey) return;
    var pricingEndpoint = this.cfg.pricingEndpoint;
    if (!pricingEndpoint) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var item = cart.items.filter(function (it) { return it.key === editKey; })[0];
        if (!item || !item.handle || item.handle.indexOf('internal-') !== 0) return;
        return fetch(pricingEndpoint + '/line-config?lineKey=' + encodeURIComponent(editKey))
          .then(function (res) { if (!res.ok) throw new Error('sin config guardada'); return res.json(); })
          .then(function (data) {
            self._editingLineKey = editKey;
            self._applyConfigSnapshot(data.config);
            if (self.elAddCart) self.elAddCart.textContent = 'Actualizar carrito';
          });
      })
      .catch(function () {});
  };

  // ─── CARRITO ─────────────────────────────────────────────────────────────────

  // Actualiza al instante el número de la burbuja del icono del carrito
  // (por defecto solo se refresca al entrar en /cart o abrir el drawer).
  function updateCartBubble() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('#cart-icon-bubble').forEach(function (icon) {
          var bubble = icon.querySelector('.cart-count-bubble');
          if (cart.item_count > 0) {
            if (!bubble) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble';
              icon.appendChild(bubble);
            }
            bubble.innerHTML =
              (cart.item_count < 100 ? '<span aria-hidden="true">' + cart.item_count + '</span>' : '') +
              '<span class="visually-hidden">' + cart.item_count + '</span>';
          } else if (bubble) {
            bubble.remove();
          }
        });
      })
      .catch(function () {});
  }

  // Pide al Worker de precio dinámico una variante nueva con el precio exacto.
  // Devuelve una promesa que resuelve al id numérico de esa variante.
  function getDynamicPriceVariantId(pricingEndpoint, price, productId, productHandle) {
    return fetch(pricingEndpoint + '/create-price-variant', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ price: price, productId: productId, productHandle: productHandle })
    })
      .then(function (res) { if (!res.ok) throw new Error('No se pudo calcular el precio dinámico'); return res.json(); })
      .then(function (data) { return data.variantId; });
  }

  function getProductHandle(productUrl) {
    if (!productUrl) return '';
    var parts = productUrl.split('/').filter(Boolean);
    return parts[parts.length - 1] || '';
  }

  // Un link "pegado" de archivo de diseño solo cuenta como tal si es de verdad
  // una URL http(s) — evita guardar texto suelto (ej. "ya subidos") como si
  // fuera el enlace del archivo.
  function isValidUrl(str) {
    if (!str) return false;
    try {
      var u = new URL(str);
      return u.protocol === 'http:' || u.protocol === 'https:';
    } catch (e) {
      return false;
    }
  }

  function sleep(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  // La variante se crea vía Admin API y tarda unos segundos en propagarse al
  // storefront; si /cart/add.js aún no la ve, reintenta con espera creciente.
  function addToCartWithRetry(variantId, quantity, properties, attempt) {
    attempt = attempt || 0;
    var payload = JSON.stringify({ items: [{ id: variantId, quantity: quantity, properties: properties }] });

    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: payload })
      .then(function (res) {
        if (res.ok) return res.json();
        return res.json().then(function (e) {
          var isStockError = /agotado|not enough|no se encontró la variante/i.test(e.description || e.message || '');
          if (isStockError && attempt < 3) {
            return sleep(1000 * (attempt + 1)).then(function () {
              return addToCartWithRetry(variantId, quantity, properties, attempt + 1);
            });
          }
          throw new Error(e.description || e.message || 'Error');
        });
      });
  }

  // Cada diseño distinto necesita su propio archivo o link (subido o pegado).
  ImprivicCalculator.prototype._hasArchivo = function () {
    var count = this._requiredArchivoCount();
    for (var i = 0; i < count; i++) {
      var tieneArchivo = this._archivoFiles[i] || this._archivoUrls[i] || (this._archivoLinkValues[i] && isValidUrl(this._archivoLinkValues[i]));
      if (!tieneArchivo) return false;
    }
    if (count > 1) {
      var cantidad = parseInt(this.elCantidad ? this.elCantidad.value : 1) || 0;
      var suma = 0;
      for (var j = 0; j < count; j++) suma += (this._archivoQtys[j] || 0);
      if (suma !== cantidad) return false;
    }
    return true;
  };

  // El aviso se muestra siempre que el botón esté gris por falta de archivo,
  // para que el cliente sepa qué le falta (antes solo salía al pulsar).
  ImprivicCalculator.prototype._refreshAddCartState = function () {
    var calculado = this._last && !this._last.hayIncompat;
    if (this.elArchivoAviso) {
      this.elArchivoAviso.style.display = (calculado && !this._hasArchivo()) ? 'block' : 'none';
    }
    if (this.elAddCart && calculado) {
      this.elAddCart.disabled = !this._hasArchivo();
    }
  };

  ImprivicCalculator.prototype._addToCart = function () {
    if (!this._last || this._last.hayIncompat) return;
    if (!this._hasArchivo()) {
      var elAviso = this._el('calc-archivo-aviso');
      if (elAviso) elAviso.style.display = 'block';
      return;
    }
    var self = this;
    var r    = this._last;
    var pricingEndpoint = this.cfg.pricingEndpoint;

    var isEditing = !!this._editingLineKey;
    if (this.elAddCart) { this.elAddCart.disabled = true; this.elAddCart.textContent = isEditing ? 'Actualizando…' : 'Añadiendo…'; }
    if (this.elCartMsg) this.elCartMsg.style.display = 'none';
    if (this.elLoadingOverlay) this.elLoadingOverlay.style.display = 'flex';

    // ── Archivo(s) de diseño: los que estén pendientes de subir se suben ahora
    // (no en cuanto se seleccionaron), justo antes de añadir al carrito.
    var count = this._requiredArchivoCount();
    var uploadPromises = [];
    var _loop = function (i) {
      if (self._archivoFiles[i]) {
        if (!pricingEndpoint) {
          uploadPromises.push(Promise.reject(new Error('No se pudo subir el archivo (falta configurar el endpoint)')));
        } else {
          uploadPromises.push(uploadArchivoFile(pricingEndpoint, self._archivoFiles[i]).then(function (url) {
            self._archivoUrls[i] = url;
            self._archivoFiles[i] = null;
            return url;
          }));
        }
      } else {
        var linkVal = isValidUrl(self._archivoLinkValues[i]) ? self._archivoLinkValues[i] : '';
        uploadPromises.push(Promise.resolve(self._archivoUrls[i] || linkVal || ''));
      }
    };
    for (var i = 0; i < count; i++) _loop(i);

    var archivoUrlsPromise = Promise.all(uploadPromises).then(function (urls) {
      self._archivoUrls = urls.slice();
      return urls;
    });

    archivoUrlsPromise
      .then(function (archivoUrls) {
        var props = {};
        props['Material']          = r.mat.nombre;
        props['Ancho']             = r.ancho + ' cm';
        props['Alto']              = r.alto  + ' cm';
        props['m² por unidad']     = fmtM2(r.m2Ud) + ' m²';
        props['m² totales pedido'] = fmtM2(r.m2Total) + ' m²';
        props['Tramo']             = r.tramo.key;
        props['Tipo de corte']     = r.corteVal;

        if (r.laminadoVal   && r.laminadoVal   !== 'no') props['Laminado']    = r.laminadoVal;
        if (r.adhesivadoVal && r.adhesivadoVal !== 'no') props['Adhesivado']  = r.adhesivadoVal;
        if (r.barnizadoVal  && r.barnizadoVal  !== 'no') props['Barnizado']   = r.barnizadoVal;

        if (!r.esSinRef) {
          props[self.motor === 'lona' ? 'Refuerzo' : 'Confección'] = r.refNombre;
          if (r.posNombre) props['Posición refuerzo'] = r.posNombre;
          if (self.motor === 'lona' && r.refuerzoVal === 'jareton-vaina' && r.jaretonDiam) props['Diámetro vaina'] = r.jaretonDiam + ' cm';
        }
        if (!r.esSinOjal) {
          props['Ojales'] = r.ojalNombre;
          if (r.posicionOjal && r.posicionOjal !== 'perimetro') props['Posición ojales'] = r.posicionOjal;
          if (r.distanciaOjal) props['Distancia ojales'] = r.distanciaOjal + ' cm';
        }

        if (self.elPapelTransp && self.elPapelTransp.checked) props['Papel transportador'] = 'Sí';
        if (archivoUrls.length === 1) {
          if (archivoUrls[0]) props['Archivo de diseño'] = archivoUrls[0];
        } else {
          archivoUrls.forEach(function (u, idx) {
            if (u) props['Archivo de diseño ' + (idx + 1)] = u;
            props['Unidades diseño ' + (idx + 1)] = (self._archivoQtys[idx] || 0) + ' ud';
          });
        }

        props['Revisión archivos']        = r.revVal === 'si' ? 'Sí (' + r.nDis + ' diseño' + (r.nDis > 1 ? 's' : '') + (self.cfg.revisionPrecio ? '' : ', gratis profesional') + ')' : 'No';
        props['Plazo de entrega']         = r.plazoNombre;
        props['Unidades']                 = r.cantidad + ' ud' + (r.cantidad > 1 ? 's' : '');
        if (self.elComentarios && self.elComentarios.value.trim()) props['Comentarios'] = self.elComentarios.value.trim();

        var variantIdPromise, cartQuantity;
        if (pricingEndpoint) {
          // Variante nueva con el precio POR UNIDAD (r.precioUd); el carrito ya multiplica
          // por cartQuantity, así que pasar r.precioTotal aquí duplicaría la multiplicación.
          variantIdPromise = getDynamicPriceVariantId(pricingEndpoint, r.precioUd, self.container.dataset.productId, getProductHandle(self.cfg.productUrl));
          cartQuantity = r.cantidad;
        } else {
          // Fallback sin Worker configurado: variante fija a 0,01€, quantity codifica el precio.
          variantIdPromise = Promise.resolve(parseInt(self.variantId));
          cartQuantity = Math.round(r.precioTotal * 100);
        }

        return variantIdPromise
          .then(function (variantId) { return addToCartWithRetry(variantId, cartQuantity, props); })
          .then(function (data) {
            // La config de "editar línea" se guarda aparte (Worker), indexada
            // por la clave de esta línea del carrito — así no queda como
            // propiedad visible en el pedido de Shopify Admin.
            var addedItem = (data && data.items && data.items[0]) || data;
            if (pricingEndpoint && addedItem && addedItem.key) {
              fetch(pricingEndpoint + '/save-line-config', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ lineKey: addedItem.key, config: self._getConfigSnapshot() })
              }).catch(function () {});
            }
            return data;
          });
      })
      .then(function () {
        if (isEditing) {
          return fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: self._editingLineKey, quantity: 0 })
          });
        }
      })
      .then(function () {
        if (self.elCartMsg) { self.elCartMsg.style.display = 'block'; self.elCartMsg.className = 'imprivic-calc__cart-msg imprivic-calc__cart-msg--ok'; self.elCartMsg.textContent = isEditing ? '✓ Línea del carrito actualizada.' : '✓ Producto añadido al carrito correctamente.'; }
        if (isEditing) {
          self._editingLineKey = null;
          var url = new URL(window.location.href);
          url.searchParams.delete('edit_line');
          window.history.replaceState({}, '', url);
        }
        updateCartBubble();
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      })
      .catch(function (err) {
        if (self.elCartMsg) { self.elCartMsg.style.display = 'block'; self.elCartMsg.className = 'imprivic-calc__cart-msg imprivic-calc__cart-msg--error'; self.elCartMsg.textContent = '✗ Error al añadir: ' + err.message; }
      })
      .finally(function () {
        if (self.elAddCart) { self.elAddCart.disabled = false; self.elAddCart.textContent = self._editingLineKey ? 'Actualizar carrito' : 'Añadir al carrito'; }
        if (self.elLoadingOverlay) self.elLoadingOverlay.style.display = 'none';
      });
  };

  // ─── INIT ────────────────────────────────────────────────────────────────────

  function init() {
    var container = document.getElementById('imprivic-calculator');
    if (!container) return;
    document.querySelectorAll('.product-form__buttons, .product-form__quantity, .product-form__input, .quantity__rules, quantity-popover').forEach(function (el) { el.style.display = 'none'; });
    new ImprivicCalculator(container);
    initStickyBuyBar(container, 'calc-precio-total', 'calc-add-cart');
  }

  // ── Barra fija de compra (solo móvil, ver .imp-sticky-buy en el CSS) ────────
  // Refleja el total y el estado del botón real de la calculadora. Si aún no se
  // puede comprar, lleva al cliente a lo que le falta; se oculta cuando el botón
  // real está a la vista para no duplicarlo.
  function initStickyBuyBar(container, priceId, buttonId) {
    var priceEl = document.getElementById(priceId);
    var mainBtn = document.getElementById(buttonId);
    if (!priceEl || !mainBtn) return;

    var bar = document.createElement('div');
    bar.className = 'imp-sticky-buy';
    bar.innerHTML =
      '<div class="imp-sticky-buy__price">' +
        '<span class="imp-sticky-buy__label">Total (sin IVA)</span>' +
        '<strong class="imp-sticky-buy__amount">—</strong>' +
      '</div>' +
      '<button type="button" class="imp-sticky-buy__btn"></button>';
    document.body.appendChild(bar);
    document.body.classList.add('imp-has-sticky-buy');

    var amountEl = bar.querySelector('.imp-sticky-buy__amount');
    var barBtn   = bar.querySelector('.imp-sticky-buy__btn');

    function hasPrice() {
      var t = (priceEl.textContent || '').trim();
      return t !== '' && t !== '—';
    }

    function sync() {
      amountEl.textContent = hasPrice() ? priceEl.textContent.trim() : '—';
      if (!mainBtn.disabled) {
        barBtn.textContent = mainBtn.textContent.trim() || 'Añadir al carrito';
        barBtn.classList.remove('imp-sticky-buy__btn--pending');
      } else if (/…$/.test(mainBtn.textContent.trim())) {
        barBtn.textContent = mainBtn.textContent.trim();   // "Añadiendo…"
        barBtn.classList.add('imp-sticky-buy__btn--pending');
      } else {
        barBtn.textContent = hasPrice() ? 'Sube tu archivo' : 'Configura tu pedido';
        barBtn.classList.add('imp-sticky-buy__btn--pending');
      }
    }

    barBtn.addEventListener('click', function () {
      if (!mainBtn.disabled) { mainBtn.click(); return; }
      var target = hasPrice()
        ? (container.querySelector('.imprivic-calc__section--upload') || mainBtn)
        : container;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    var observer = new MutationObserver(sync);
    observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
    observer.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('imp-sticky-buy--hidden', entries[0].isIntersecting);
      }).observe(mainBtn);
    }

    sync();
  }


  // ═══════════════════════════════════════════════════════════════════════════
  // MINI-CALCULADORA PLV (precio fijo por tramos de cantidad)
  // ═══════════════════════════════════════════════════════════════════════════

  ImprivicCalculatorPLV.prototype._el = function (id) {
    return this.container.querySelector('#' + id) || document.getElementById(id);
  };

  function ImprivicCalculatorPLV(container) {
    var cfg = window.IMPRIVIC_PLV_CONFIG;
    if (!cfg || !cfg.variantes || cfg.variantes.length === 0) {
      console.warn('[ImprivicCalcPLV] IMPRIVIC_PLV_CONFIG no encontrado');
      return;
    }
    this.container = container;
    this.cfg       = cfg;
    this.variantId = container.dataset.variantId;
    this._last     = null;
    this._editingLineKey = null;

    this.elVariante   = container.querySelector('#calc-plv-variante') || document.getElementById('calc-plv-variante');
    this.elCantidad   = container.querySelector('#calc-plv-cantidad') || document.getElementById('calc-plv-cantidad');
    this.elTramoInfo  = container.querySelector('#calc-plv-tramo-info') || document.getElementById('calc-plv-tramo-info');
    this.elResultado  = container.querySelector('#calc-plv-resultado') || document.getElementById('calc-plv-resultado');
    this.elDesglose   = container.querySelector('#calc-plv-desglose') || document.getElementById('calc-plv-desglose');
    this.elTotal      = container.querySelector('#calc-plv-precio-total') || document.getElementById('calc-plv-precio-total');
    this.elAddCart    = container.querySelector('#calc-plv-add-cart') || document.getElementById('calc-plv-add-cart');
    this.elCartMsg    = container.querySelector('#calc-plv-cart-msg') || document.getElementById('calc-plv-cart-msg');
    this.elLoadingOverlay = container.querySelector('#calc-plv-loading-overlay') || document.getElementById('calc-plv-loading-overlay');
    if (this.elLoadingOverlay) document.body.appendChild(this.elLoadingOverlay);

    this.hasPlantilla       = !!cfg.hasPlantilla;
    // Mismo sistema que la calculadora por m²: un bloque de subida por diseño
    // distinto, cada uno con sus unidades (ver _renderArchivoSlots).
    this.elArchivoSlots     = this._el('calc-plv-archivo-slots');
    this.elArchivoAviso     = this._el('calc-plv-archivo-aviso');
    this._archivoFiles      = [];
    this._archivoUrls       = [];
    this._archivoLinkValues = [];
    this._archivoQtys       = [];
    this.elComentarios      = this._el('calc-plv-comentarios');
    this.elRevision         = this._el('calc-plv-revision');
    this.elRevWrapper       = this._el('calc-plv-revision-disenos');
    this.elNumDisenos       = this._el('calc-plv-num-disenos');
    this.elPlazo            = this._el('calc-plv-plazo');

    var self = this;
    if (self.elVariante) self.elVariante.addEventListener('change', function () { self._calculate(); });
    if (self.elRevision) self.elRevision.addEventListener('change', function () { self._calculate(); });
    // Nº de diseños: rehace los bloques de subida (uno por diseño) y recalcula la revisión.
    if (self.elNumDisenos) {
      self.elNumDisenos.addEventListener('input',  function () { self._clampNumDisenos(); self._renderArchivoSlots(); self._calculate(); });
      self.elNumDisenos.addEventListener('change', function () { self._clampNumDisenos(); self._renderArchivoSlots(); self._calculate(); });
    }
    if (self.elPlazo) self.elPlazo.addEventListener('change', function () { self._calculate(); });
    // La cantidad cambia cuántas unidades hay que repartir entre diseños (no se
    // rehacen los bloques para no perder lo ya subido).
    if (self.elCantidad) {
      self.elCantidad.addEventListener('input',  function () { self._calculate(); self._updateArchivoQtySummary(); self._refreshAddCartState(); });
      self.elCantidad.addEventListener('change', function () { self._calculate(); self._updateArchivoQtySummary(); self._refreshAddCartState(); });
    }
    if (self.elAddCart) self.elAddCart.addEventListener('click', function () { self._addToCart(); });

    self._clampNumDisenos();
    self._renderArchivoSlots();
    self._calculate();
    self._checkEditMode();
  }

  ImprivicCalculatorPLV.prototype._checkEditMode = function () {
    var self = this;
    var editKey = new URLSearchParams(window.location.search).get('edit_line');
    if (!editKey) return;
    var pricingEndpoint = this.cfg.pricingEndpoint;
    if (!pricingEndpoint) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var item = cart.items.filter(function (it) { return it.key === editKey; })[0];
        if (!item || !item.handle || item.handle.indexOf('internal-') !== 0) return;
        return fetch(pricingEndpoint + '/line-config?lineKey=' + encodeURIComponent(editKey))
          .then(function (res) { if (!res.ok) throw new Error('sin config guardada'); return res.json(); })
          .then(function (data) {
            var snap = data.config;
            self._editingLineKey = editKey;
            if (self.elVariante && snap.variante !== undefined) self.elVariante.value = snap.variante;
            if (self.elCantidad && snap.cantidad !== undefined) self.elCantidad.value = snap.cantidad;
            if (self.elComentarios && snap.comentarios) self.elComentarios.value = snap.comentarios;
            if (self.elRevision && snap.revision) self.elRevision.value = snap.revision;
            if (self.elNumDisenos && snap.numDisenos) self.elNumDisenos.value = snap.numDisenos;
            if (self.elPlazo && snap.plazo && self.elPlazo.querySelector('option[value="' + snap.plazo + '"]')) self.elPlazo.value = snap.plazo;
            // Compatibilidad con líneas guardadas antes de admitir un archivo por diseño.
            var urls = snap._archivoUrls || (snap._archivoUrl ? [snap._archivoUrl] : []);
            self._archivoUrls = urls.slice();
            self._archivoFiles = [];
            self._archivoLinkValues = [];
            self._archivoQtys = (snap._archivoQtys || []).slice();
            self._clampNumDisenos();
            self._renderArchivoSlots();
            self._calculate();
            if (self.elAddCart) self.elAddCart.textContent = 'Actualizar carrito';
          });
      })
      .catch(function () {});
  };

  ImprivicCalculatorPLV.prototype._clampNumDisenos = clampNumDisenos;

  // Subida por diseño: se reutiliza tal cual la de la calculadora por m² (en una
  // página nunca hay las dos calculadoras a la vez, así que no chocan los ids).
  ['_requiredArchivoCount', '_renderArchivoSlots', '_setArchivoQty', '_updateArchivoQtySummary', '_showArchivoSlotPreview'].forEach(function (m) {
    ImprivicCalculatorPLV.prototype[m] = ImprivicCalculator.prototype[m];
  });

  ImprivicCalculatorPLV.prototype._hasArchivo = function () {
    // requireArchivo lo activa el interruptor _plv_archivo_obligatorio del snippet.
    if (!this.hasPlantilla && !this.cfg.requireArchivo) return true;
    return ImprivicCalculator.prototype._hasArchivo.call(this);
  };

  ImprivicCalculatorPLV.prototype._refreshAddCartState = function () {
    var elAviso = this._el('calc-plv-archivo-aviso');
    if (elAviso) elAviso.style.display = (this._last && !this._hasArchivo()) ? 'block' : 'none';
    if (this.elAddCart && this._last) {
      this.elAddCart.disabled = !this._hasArchivo();
    }
  };

  ImprivicCalculatorPLV.prototype._getVariante = function () {
    var idx = this.elVariante ? parseInt(this.elVariante.value) || 0 : 0;
    return this.cfg.variantes[idx] || this.cfg.variantes[0];
  };

  // Devuelve el tramo aplicable para una cantidad dada.
  // Regla: el tramo cuya qty sea la más alta <= cantidad pedida.
  // Si cantidad < primer tramo, usa el primer tramo.
  ImprivicCalculatorPLV.prototype._getTramo = function (variante, cantidad) {
    var tramos = variante.tramos;
    var aplicable = tramos[0];
    for (var i = 0; i < tramos.length; i++) {
      if (cantidad >= tramos[i].qty) aplicable = tramos[i];
    }
    return aplicable;
  };

  ImprivicCalculatorPLV.prototype._calculate = function () {
    var cantidad = parseInt(this.elCantidad ? this.elCantidad.value : 1) || 0;
    if (cantidad <= 0) { this._hideResult(); return; }

    var variante = this._getVariante();
    var tramo    = this._getTramo(variante, cantidad);
    var precioBaseUd = tramo.price;

    // ── Revisión: precio por diseño, repartido entre las unidades (como en la calculadora por m²)
    this._clampNumDisenos();
    var revVal   = this.elRevision ? this.elRevision.value : 'no';
    var nDis     = parseInt(this.elNumDisenos ? this.elNumDisenos.value : 1, 10) || 1;
    var totalRev = revVal === 'si' ? nDis * (this.cfg.revisionPrecio || 0) : 0;
    var revProrr = totalRev / cantidad;

    // ── Plazo: multiplicador final sobre precio + revisión
    var plazoKey  = this.elPlazo ? this.elPlazo.value : '7d';
    var plazoMult = (this.cfg.plazos || {})[plazoKey] || 1;
    var plazoNombre = ({ '48h': '48 horas', '5d': '5 días laborables', '7d': '7 días laborables', '10d': '10 días laborables' })[plazoKey] || plazoKey;

    var precioUd = (precioBaseUd + revProrr) * plazoMult;
    var total    = precioUd * cantidad;

    // Tramo info
    if (this.elTramoInfo) {
      // Siguiente tramo (si existe)
      var tramos    = variante.tramos;
      var tramoIdx  = tramos.indexOf(tramo);
      var siguiente = tramos[tramoIdx + 1];
      var msg       = 'Precio unitario tramo ≥' + tramo.qty + ' ud: ' + fmt(precioBaseUd);
      if (siguiente) {
        msg += ' — A partir de ' + siguiente.qty + ' ud: ' + fmt(siguiente.price) + '/ud';
      }
      this.elTramoInfo.textContent = msg;
      this.elTramoInfo.style.display = 'block';
    }

    this._last = {
      variante: variante, tramo: tramo, cantidad: cantidad,
      precioBaseUd: precioBaseUd, revVal: revVal, nDis: nDis, totalRev: totalRev, revProrr: revProrr,
      plazoKey: plazoKey, plazoMult: plazoMult, plazoNombre: plazoNombre,
      precioUd: precioUd, total: total
    };
    this._updateUI();
  };

  ImprivicCalculatorPLV.prototype._updateUI = function () {
    if (!this._last || !this.elDesglose) return;
    var r = this._last;
    var rows = [];

    rows.push('<tr><td class="imprivic-calc__label-col">Variante</td><td>' + r.variante.variante + '</td></tr>');
    rows.push('<tr><td class="imprivic-calc__label-col">Cantidad</td><td>' + r.cantidad + ' ud</td></tr>');
    rows.push('<tr><td class="imprivic-calc__label-col">Precio unitario (tramo ≥' + r.tramo.qty + ' ud)</td><td>' + fmt(r.precioBaseUd) + '</td></tr>');
    if (r.totalRev > 0) {
      rows.push('<tr><td class="imprivic-calc__label-col">Revisión archivos (' + r.nDis + ' diseño' + (r.nDis > 1 ? 's' : '') + ' × ' + fmt(this.cfg.revisionPrecio) + ' = ' + fmt(r.totalRev) + ')</td><td>' + fmt(r.revProrr) + '/ud</td></tr>');
    } else if (r.revVal === 'si') {
      rows.push('<tr><td class="imprivic-calc__label-col">Revisión archivos (' + r.nDis + ' diseño' + (r.nDis > 1 ? 's' : '') + ')</td><td>Gratis</td></tr>');
    }
    if (r.plazoMult !== 1) {
      rows.push('<tr><td class="imprivic-calc__label-col">Plazo (' + r.plazoNombre + ')</td><td>× ' + r.plazoMult.toFixed(2) + '</td></tr>');
    }
    if (r.precioUd !== r.precioBaseUd) {
      rows.push('<tr class="imprivic-calc__unit-row"><td class="imprivic-calc__label-col">Precio por unidad (sin IVA)</td><td>' + fmt(r.precioUd) + '</td></tr>');
    }
    // Sin selector de plazo (mejoras PLV desactivadas) se mantiene el plazo orientativo del tramo.
    if (!this.elPlazo && r.tramo.plazo) {
      rows.push('<tr><td class="imprivic-calc__label-col">Plazo orientativo</td><td class="imprivic-calc__plazo-col">' + r.tramo.plazo + '</td></tr>');
    }

    this.elDesglose.innerHTML = '<table class="imprivic-calc__table">' + rows.join('') + '</table>';

    // Tabla de tramos: solo tiene sentido mostrarla si hay más de un tramo de precio.
    if (r.variante.tramos.length > 1) {
      var tramoRows = r.variante.tramos.map(function (t) {
        var isActive = t === r.tramo;
        var rowClass = isActive ? ' class="imprivic-calc__tramo-row--active"' : '';
        var plazoCell = t.plazo ? '<td class="imprivic-calc__plazo-col">' + t.plazo + '</td>' : '<td></td>';
        return '<tr' + rowClass + '><td>A partir de ' + t.qty + ' ud</td><td>' + fmt(t.price) + '/ud</td>' + plazoCell + '</tr>';
      }).join('');
      var tramoTable =
        '<table class="imprivic-calc__table imprivic-calc__table--tramos">' +
          '<thead><tr><th>Cantidad</th><th>Precio/ud</th><th>Plazo</th></tr></thead>' +
          '<tbody>' + tramoRows + '</tbody>' +
        '</table>';
      this.elDesglose.innerHTML += '<p class="imprivic-calc__tabla-precios-label">Tabla de precios</p>' + tramoTable;
    }
    if (this.elTotal)   this.elTotal.textContent = fmt(r.total);
    this._refreshAddCartState();
    if (this.elResultado) this.elResultado.style.display = 'block';

    // Sync page price
    document.querySelectorAll('.product__info-container .price-item--regular, .product__info-container .price-item--sale').forEach(function (el) {
      if (!el.dataset.imprivicOriginal) el.dataset.imprivicOriginal = el.textContent.trim();
      el.textContent = fmt(r.total);
    });
  };

  ImprivicCalculatorPLV.prototype._hideResult = function () {
    if (this.elResultado) this.elResultado.style.display = 'none';
    if (this.elTramoInfo) this.elTramoInfo.style.display = 'none';
    if (this.elAddCart)   this.elAddCart.disabled = true;
    this._last = null;
  };

  ImprivicCalculatorPLV.prototype._addToCart = function () {
    if (!this._last) return;
    if (!this._hasArchivo()) {
      var elAviso = this._el('calc-plv-archivo-aviso');
      if (elAviso) elAviso.style.display = 'block';
      return;
    }
    var self = this;
    var r    = this._last;
    var pricingEndpoint = this.cfg.pricingEndpoint;

    var isEditing = !!this._editingLineKey;
    if (self.elAddCart) { self.elAddCart.disabled = true; self.elAddCart.textContent = isEditing ? 'Actualizando…' : 'Añadiendo…'; }
    if (self.elCartMsg) self.elCartMsg.style.display = 'none';
    if (self.elLoadingOverlay) self.elLoadingOverlay.style.display = 'flex';

    // Archivo(s) de diseño: uno por diseño distinto; los pendientes se suben ahora.
    var count = this._requiredArchivoCount();
    var uploadPromises = [];
    var _loop = function (i) {
      if (self._archivoFiles[i]) {
        if (!pricingEndpoint) {
          uploadPromises.push(Promise.reject(new Error('No se pudo subir el archivo (falta configurar el endpoint)')));
        } else {
          uploadPromises.push(uploadArchivoFile(pricingEndpoint, self._archivoFiles[i]).then(function (url) {
            self._archivoUrls[i] = url;
            self._archivoFiles[i] = null;
            return url;
          }));
        }
      } else {
        var linkVal = isValidUrl(self._archivoLinkValues[i]) ? self._archivoLinkValues[i] : '';
        uploadPromises.push(Promise.resolve(self._archivoUrls[i] || linkVal || ''));
      }
    };
    for (var i = 0; i < count; i++) _loop(i);

    Promise.all(uploadPromises)
      .then(function (archivoUrls) {
        self._archivoUrls = archivoUrls.slice();
        var props = {};
        props['Variante']                 = r.variante.variante;
        props['Cantidad']                 = r.cantidad + ' ud';
        props['Precio unitario (sin IVA)']= fmt(r.precioUd);
        if (self.elRevision) props['Revisión archivos'] = r.revVal === 'si' ? 'Sí (' + r.nDis + ' diseño' + (r.nDis > 1 ? 's' : '') + (self.cfg.revisionPrecio ? '' : ', gratis profesional') + ')' : 'No';
        if (self.elPlazo) props['Plazo de entrega'] = r.plazoNombre;
        else if (r.tramo.plazo) props['Plazo orientativo'] = r.tramo.plazo;
        else if (r.variante.plazos) props['Plazo orientativo'] = r.variante.plazos;
        if (archivoUrls.length === 1) {
          if (archivoUrls[0]) props['Archivo de diseño'] = archivoUrls[0];
        } else {
          archivoUrls.forEach(function (u, idx) {
            if (u) props['Archivo de diseño ' + (idx + 1)] = u;
            props['Unidades diseño ' + (idx + 1)] = (self._archivoQtys[idx] || 0) + ' ud';
          });
        }
        if (self.elComentarios && self.elComentarios.value.trim()) props['Comentarios'] = self.elComentarios.value.trim();

        var configSnap = {
          variante: self.elVariante ? self.elVariante.value : '0',
          cantidad: r.cantidad,
          comentarios: self.elComentarios ? self.elComentarios.value.trim() : '',
          revision: r.revVal,
          numDisenos: r.nDis,
          plazo: r.plazoKey,
          _archivoUrls: archivoUrls.some(Boolean) ? archivoUrls : undefined,
          _archivoQtys: count > 1 ? self._archivoQtys.slice() : undefined
        };

        var variantIdPromise, cartQuantity;
        if (pricingEndpoint) {
          // Precio POR UNIDAD (r.precioUd): el carrito multiplica por cartQuantity.
          variantIdPromise = getDynamicPriceVariantId(pricingEndpoint, r.precioUd, self.container.dataset.productId, getProductHandle(self.cfg.productUrl));
          cartQuantity = r.cantidad;
        } else {
          variantIdPromise = Promise.resolve(parseInt(self.variantId));
          cartQuantity = Math.round(r.total * 100);
        }

        return variantIdPromise
          .then(function (variantId) { return addToCartWithRetry(variantId, cartQuantity, props); })
          .then(function (data) {
            var addedItem = (data && data.items && data.items[0]) || data;
            if (pricingEndpoint && addedItem && addedItem.key) {
              fetch(pricingEndpoint + '/save-line-config', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ lineKey: addedItem.key, config: configSnap })
              }).catch(function () {});
            }
            return data;
          });
      })
    .then(function () {
      if (isEditing) {
        return fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: self._editingLineKey, quantity: 0 })
        });
      }
    })
    .then(function () {
      if (self.elCartMsg) {
        self.elCartMsg.style.display = 'block';
        self.elCartMsg.className = 'imprivic-calc__cart-msg imprivic-calc__cart-msg--ok';
        self.elCartMsg.textContent = isEditing ? '✓ Línea del carrito actualizada.' : '✓ Producto añadido al carrito correctamente.';
      }
      if (isEditing) {
        self._editingLineKey = null;
        var url = new URL(window.location.href);
        url.searchParams.delete('edit_line');
        window.history.replaceState({}, '', url);
      }
      updateCartBubble();
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    })
    .catch(function (err) {
      if (self.elCartMsg) {
        self.elCartMsg.style.display = 'block';
        self.elCartMsg.className = 'imprivic-calc__cart-msg imprivic-calc__cart-msg--error';
        self.elCartMsg.textContent = '✗ Error al añadir: ' + err.message;
      }
    })
    .finally(function () {
      if (self.elAddCart) { self.elAddCart.disabled = false; self.elAddCart.textContent = self._editingLineKey ? 'Actualizar carrito' : 'Añadir al carrito'; }
      if (self.elLoadingOverlay) self.elLoadingOverlay.style.display = 'none';
    });
  };


  // ── Tooltips de los iconos "i" (.imp-info-icon[data-tip]) ─────────────────────
  // Un único div reutilizado y anclado al body, para no depender de overflow/
  // position de los contenedores de la calculadora.
  function initInfoTooltips() {
    var tooltipEl = null;

    function getTooltipEl() {
      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'imp-tooltip';
        tooltipEl.setAttribute('role', 'tooltip');
        document.body.appendChild(tooltipEl);
      }
      return tooltipEl;
    }

    function showTooltip(icon) {
      var text = icon.getAttribute('data-tip');
      if (!text) return;
      var el = getTooltipEl();
      el.textContent = text;
      el.style.display = 'block';

      var iconRect = icon.getBoundingClientRect();
      var tipRect  = el.getBoundingClientRect();
      var top  = iconRect.top - tipRect.height - 8 + window.scrollY;
      var left = iconRect.left + (iconRect.width / 2) - (tipRect.width / 2) + window.scrollX;

      if (top < window.scrollY) top = iconRect.bottom + 8 + window.scrollY;
      var minLeft = 8 + window.scrollX;
      var maxLeft = window.scrollX + document.documentElement.clientWidth - tipRect.width - 8;
      if (left < minLeft) left = minLeft;
      if (left > maxLeft) left = maxLeft;

      el.style.top  = top + 'px';
      el.style.left = left + 'px';
    }

    function hideTooltip() {
      if (tooltipEl) tooltipEl.style.display = 'none';
    }

    document.addEventListener('mouseover', function (e) {
      var icon = e.target.closest && e.target.closest('.imp-info-icon');
      if (icon) showTooltip(icon);
    });
    document.addEventListener('mouseout', function (e) {
      var icon = e.target.closest && e.target.closest('.imp-info-icon');
      if (icon) hideTooltip();
    });
    document.addEventListener('focusin', function (e) {
      var icon = e.target.closest && e.target.closest('.imp-info-icon');
      if (icon) showTooltip(icon);
    });
    document.addEventListener('focusout', function (e) {
      var icon = e.target.closest && e.target.closest('.imp-info-icon');
      if (icon) hideTooltip();
    });
    // Táctil: alternar en el primer toque, ya que no hay hover.
    document.addEventListener('click', function (e) {
      var icon = e.target.closest && e.target.closest('.imp-info-icon');
      if (icon) {
        e.preventDefault();
        var el = getTooltipEl();
        if (el.style.display === 'block' && el.textContent === icon.getAttribute('data-tip')) {
          hideTooltip();
        } else {
          showTooltip(icon);
        }
      } else {
        hideTooltip();
      }
    });
  }

  // ── Init PLV ─────────────────────────────────────────────────────────────────
  function initPLV() {
    var container = document.getElementById('imprivic-calculator-plv');
    if (!container) return;
    document.querySelectorAll('.product-form__buttons, .product-form__quantity, .product-form__input, .quantity__rules, quantity-popover').forEach(function (el) { el.style.display = 'none'; });
    new ImprivicCalculatorPLV(container);
    initStickyBuyBar(container, 'calc-plv-precio-total', 'calc-plv-add-cart');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initPLV(); initInfoTooltips(); });
  } else {
    init();
    initPLV();
    initInfoTooltips();
  }


})();